import React, { useEffect, useState } from 'react';
import './AdminNavbar.css';
import { logOut } from '../../../features/redux/sessionSlice';
import { useDispatch, useSelector } from 'react-redux';
import {
  getApplications,
  getSessions,
  getLoading,
  setCurrentSessionId,
  startApplicationAsync,
  stopApplicationAsync,
} from '../../../features/redux/appSlice';
import { useNavigate } from 'react-router-dom';

function AdminNavbar({ activeTab, setActiveTab }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const applications = useSelector(getApplications);
  const sessions = useSelector(getSessions);
  const isLoading = useSelector(getLoading);
  const [applicationsOpen, setApplicationsOpen] = useState(false);
  const [currentApplication, setCurrentApplication] = useState(null);

  return (
    <nav className='navbar navbar-expand-lg navbar-light bg-light'>
      <div className='collapse navbar-collapse' id='navbarSupportedContent'>
        <div className='btn-group btn-group-toggle' data-toggle='buttons'>
          <button
            onClick={() => {
              setActiveTab('users');
            }}
            className={`btn btn-outline-primary my-2 my-sm-0 ${activeTab == 'users' ? 'active' : ''}`}
            type='submit'
          >
            Users
            {!isLoading && (
              <i style={{ marginLeft: '4px' }} className='fa-solid fa-user'></i>
            )}
            {isLoading && (
              <i
                style={{ marginLeft: '4px' }}
                className='fa fa-circle-notch fa-spin'
              ></i>
            )}
          </button>
          <button
            onClick={() => {
              setActiveTab('applications');
            }}
            className={`btn btn-outline-primary my-2 my-sm-0 ${activeTab == 'applications' ? 'active' : ''}`}
            type='submit'
          >
            Applications
            {!isLoading && (
              <i
                style={{ marginLeft: '4px' }}
                className='fa-solid fa-floppy-disk'
              ></i>
            )}
            {isLoading && (
              <i
                style={{ marginLeft: '4px' }}
                className='fa fa-circle-notch fa-spin'
              ></i>
            )}
          </button>
          <button
            onClick={() => {
              setActiveTab('sessions');
            }}
            className={`btn btn-outline-primary my-2 my-sm-0 ${activeTab == 'sessions' ? 'active' : ''}`}
            type='submit'
          >
            Sessions
            {!isLoading && (
              <i
                style={{ marginLeft: '4px' }}
                className='fa-solid fa-chart-line'
              ></i>
            )}
            {isLoading && (
              <i
                style={{ marginLeft: '4px' }}
                className='fa fa-circle-notch fa-spin'
              ></i>
            )}
          </button>
          <button
            onClick={() => {
              setActiveTab('credentials');
            }}
            className={`btn btn-outline-primary my-2 my-sm-0 ${activeTab == 'credentials' ? 'active' : ''}`}
            type='submit'
          >
            Credentials
            {!isLoading && (
              <i style={{ marginLeft: '4px' }} className='fa-solid fa-key'></i>
            )}
            {isLoading && (
              <i
                style={{ marginLeft: '4px' }}
                className='fa fa-circle-notch fa-spin'
              ></i>
            )}
          </button>
        </div>

        <div className='btn-group btn-group-toggle' data-toggle='buttons'>
          <button
            className='btn btn-outline-success my-2 my-sm-0'
            onClick={() => {
              navigate('/dashboard');
            }}
            type='submit'
          >
            Agent
          </button>
          <button
            className='btn btn-outline-danger my-2 my-sm-0'
            onClick={() => {
              dispatch(logOut());
            }}
            type='submit'
          >
            Log Out
          </button>
        </div>
      </div>
    </nav>
  );
}

export default AdminNavbar;
